__turbopack_context__.v({
  "boot": "shell-example-module__m0vUKG__boot",
  "chrome": "shell-example-module__m0vUKG__chrome",
  "connection": "shell-example-module__m0vUKG__connection",
  "cursor": "shell-example-module__m0vUKG__cursor",
  "note": "shell-example-module__m0vUKG__note",
  "output": "shell-example-module__m0vUKG__output",
  "pane": "shell-example-module__m0vUKG__pane",
  "root": "shell-example-module__m0vUKG__root",
  "sessionFooter": "shell-example-module__m0vUKG__sessionFooter",
  "shellHeader": "shell-example-module__m0vUKG__shellHeader",
  "track": "shell-example-module__m0vUKG__track",
  "trigger": "shell-example-module__m0vUKG__trigger",
  "welcome": "shell-example-module__m0vUKG__welcome",
});
